<template>
  <svg
    width="294"
    height="100"
    viewBox="0 0 294 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <rect width="294" height="99.7818" rx="23.1636" fill="#006CB1" />
    <path d="M61.2881 55.0391H69.7185V57.7812H65.7085V77.1496H61.2881V55.0391Z" fill="white" />
    <path
      d="M74.7176 68.8443L75.4754 57.7812H75.728L76.4858 68.8443H74.7176ZM69.8236 77.1496H74.1493L74.5598 71.2759H76.6437L77.0542 77.1496H81.3799L79.0749 55.0391H72.1285L69.8236 77.1496Z"
      fill="white"
    />
    <path
      d="M87.7105 69.4133V73.5765C87.7105 74.1449 88.1525 74.3028 88.4051 74.3028C88.8156 74.3028 89.0997 73.9554 89.0997 73.5765V68.4344C89.0997 67.7397 88.9734 66.9818 87.3316 66.9818H85.5318V64.5502H87.3947C88.6577 64.5502 89.0997 64.266 89.0997 62.9081V58.5133C89.0997 58.1344 88.8156 57.787 88.4051 57.787C88.1525 57.787 87.7105 57.9449 87.7105 58.5133V62.1186H83.29V58.9923C83.29 57.4449 83.4795 55.0449 86.5738 55.0449H90.2364C93.3307 55.0449 93.5202 57.4449 93.5202 58.9923V62.5291C93.5202 64.9291 91.8467 65.5923 90.5206 65.5291V65.7502C93.4886 65.687 93.5202 67.9607 93.5202 68.7502V73.2028C93.5202 74.7502 93.3307 77.1502 90.2364 77.1502H86.5738C83.4795 77.1502 83.29 74.7502 83.29 73.2028V69.4133H87.7105Z"
      fill="white"
    />
    <path
      d="M96.4302 55.0391H106.666V77.1496H102.245V57.7812H100.856V77.1496H96.4354V55.0391H96.4302Z"
      fill="white"
    />
    <path
      d="M113.996 67.2028V57.7818H114.565C115.038 57.7818 115.386 58.1923 115.386 58.887V66.0923C115.386 66.787 115.038 67.1976 114.565 67.1976H113.996V67.2028ZM109.576 77.1502H113.996V69.6344H116.522C119.617 69.6344 119.806 67.2344 119.806 65.687V58.9923C119.806 57.4449 119.617 55.0449 116.522 55.0449H109.576V77.1502Z"
      fill="white"
    />
    <path
      d="M128.526 73.5759C128.526 73.9549 128.242 74.3022 127.831 74.3022C127.579 74.3022 127.137 74.1443 127.137 73.5759V58.5075C127.137 57.9391 127.579 57.7812 127.831 57.7812C128.242 57.7812 128.526 58.1285 128.526 58.5075V73.5759ZM122.711 73.2022C122.711 74.7496 122.9 77.1496 125.995 77.1496H129.657C132.751 77.1496 132.941 74.7496 132.941 73.2022V58.9864C132.941 57.4391 132.751 55.0391 129.657 55.0391H125.995C122.9 55.0391 122.711 57.4391 122.711 58.9864V73.2022Z"
      fill="white"
    />
    <path
      d="M147.349 55.0391H153.096V77.1496H148.675V63.2812H148.518L146.244 77.1496H142.708L140.435 63.2812H140.277V77.1496H135.856V55.0391H141.603L144.476 70.5812L147.349 55.0391Z"
      fill="white"
    />
    <path
      d="M55.5571 24.8083C54.2046 18.882 50.8104 14.061 50.342 13.2715C49.6053 14.3767 46.8951 18.6346 45.5216 23.3557C44.0218 28.6189 43.8008 33.2925 44.3165 37.8925C44.8323 42.4925 46.7741 47.2136 46.7741 47.2136C47.8055 49.6926 49.3579 52.3452 50.363 53.6504C51.8365 51.7294 55.236 46.0083 56.2938 38.5294C56.8832 34.3768 56.9095 30.7347 55.5571 24.8083ZM50.342 52.1768C49.6789 50.9241 48.6422 48.5399 48.5475 44.8557C48.5212 41.2873 49.9473 38.2399 50.3683 37.5978C50.7419 38.2346 51.9681 40.8926 52.1154 44.5347C52.2102 48.0978 51.0314 50.8978 50.342 52.1768ZM55.1624 34.8715C55.1097 37.1347 54.8414 39.5189 54.4993 40.9452C54.6256 38.4873 54.3256 35.0189 53.7626 32.3083C53.1942 29.6031 51.5997 25.0768 50.3209 22.9873C49.1422 24.982 47.6897 28.8925 46.9267 32.2873C46.1636 35.682 46.1373 39.7925 46.1373 41.0241C45.9374 39.9873 45.4269 36.282 45.569 32.561C45.69 29.4926 46.4057 26.3346 46.8004 24.8873C48.3002 20.0399 49.9999 16.9452 50.3157 16.4504C50.6367 16.9452 52.7732 20.7557 53.8836 24.7662C54.9887 28.7662 55.2097 32.6031 55.1624 34.8715Z"
      fill="white"
    />
    <path
      d="M52.6365 55.0354H42.3432V61.9459C42.3537 61.9354 42.359 61.9249 42.3695 61.9196C44.7955 59.4933 48.7265 59.4933 51.1525 61.9196C53.5784 64.3459 53.5784 68.2775 51.1525 70.7038C51.1419 70.7143 51.1314 70.7196 51.1209 70.7301C51.1104 70.7407 51.0946 70.7512 51.0841 70.7617C48.6634 73.1617 45.5059 74.367 42.3432 74.367C39.17 74.367 35.9915 73.1564 33.5708 70.7354C29.3029 66.467 28.7977 59.8617 32.0499 55.0354C32.4867 54.3827 32.9972 53.7617 33.5708 53.188C35.9915 50.767 39.17 49.5564 42.3432 49.5564V32.9512C30.1397 32.9512 20.2516 42.8459 20.2516 55.0354C20.2516 67.2354 30.1397 77.1301 42.3432 77.1301C48.7055 77.1301 54.4362 74.4406 58.4672 70.1354V55.0354H52.6365Z"
      fill="white"
    />
    <path
      d="M168.168 86.1192C163.053 86.1192 158.89 81.956 158.89 76.8402V55.0192C158.89 49.9034 163.053 45.7402 168.168 45.7402H262.375C267.49 45.7402 271.653 49.9034 271.653 55.0192V76.8402C271.653 81.956 267.49 86.1192 262.375 86.1192H168.168Z"
      fill="white"
    />
    <path
      d="M262.328 82.719H168.21C164.931 82.719 162.274 80.0611 162.274 76.7821V55.0716C162.274 51.7927 164.931 49.1348 168.21 49.1348H262.139C265.517 49.1348 268.259 51.8769 268.259 55.2558V76.7821C268.259 80.0611 265.607 82.719 262.328 82.719Z"
      fill="url(#paint0_linear_7040_2545)"
    />
    <path
      d="M180.203 55.043V59.0061H173.504V63.5535H175.898C179.034 63.5535 182.35 64.9377 182.35 70.3745C182.35 75.9956 178.971 77.1061 175.898 77.1061H168.189V55.043H180.203ZM173.504 73.1377H174.425C175.961 73.1377 177.035 72.6166 177.035 70.4324C177.035 68.2219 175.835 67.5114 174.514 67.5114H173.498V73.1377H173.504Z"
      fill="white"
    />
    <path
      d="M202.321 60.7896V70.6843C202.321 75.0791 200.137 77.6264 195.164 77.6264C190.249 77.6264 188.007 75.0738 188.007 70.6843V60.758C188.007 57.2843 190.191 54.5527 195.195 54.5527C200.2 54.5527 202.321 57.3475 202.321 60.7896ZM193.317 60.4159V71.6001C193.317 72.9212 194.238 73.5685 195.159 73.5685C196.048 73.5685 197 72.9212 197 71.6001V60.4159C197 59.158 196.048 58.6054 195.159 58.6054C194.238 58.6054 193.317 59.158 193.317 60.4159Z"
      fill="white"
    />
    <path
      d="M213.561 63.5535H217.034V55.043H222.349V77.1061H217.034V67.7324H213.561V77.1061H208.246V55.043H213.561V63.5535Z"
      fill="white"
    />
    <path
      d="M233.399 55.043L235.393 64.6588C235.546 65.4588 235.546 66.9009 235.672 69.2061H235.735C235.92 66.8693 236.072 65.4903 236.256 64.6588L238.314 55.043H243.813L239.082 72.0377C237.883 76.3114 236.625 77.3535 232.91 77.3535C231.925 77.3535 230.668 77.1377 230.236 76.7693V73.0219C230.484 73.1166 231.036 73.1745 231.557 73.1745C231.989 73.1745 232.573 73.143 232.815 72.4377L227.837 55.0482H233.399V55.043Z"
      fill="white"
    />
    <path
      d="M262.317 68.3791V70.437C262.317 75.4475 260.044 77.6264 255.129 77.6264C250.245 77.6264 247.941 75.4738 247.941 70.4054V60.7896C247.941 57.3159 250.093 54.5527 255.129 54.5527C260.107 54.5527 262.317 57.3791 262.317 60.8212V62.3264H257.002V60.3317C257.002 59.1633 255.897 58.6106 255.066 58.6106C254.177 58.6106 253.256 59.1001 253.256 60.237V71.237C253.256 72.8948 253.961 73.5738 255.066 73.5738C256.203 73.5738 257.002 72.958 257.002 71.3001V68.3791H262.317Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7040_2545"
        x1="195.837"
        y1="99.5905"
        x2="234.675"
        y2="32.3308"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EF7D00" />
        <stop offset="1" stop-color="#E6007E" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  white?: boolean
}>()
</script>
